import { ToastService } from './../../../../core/toast.service';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SendOrderSupportRequestService } from '../../services/send-order-support-request.service';
import { GetSupportRequestReasonsService } from '../../services/get-support-request-reasons.service';

@Component({
  selector: 'app-second-hand-request',
  templateUrl: './second-hand-request.component.html',
  styleUrls: ['./second-hand-request.component.scss']
})
export class SecondHandRequestComponent implements OnInit {
  raiseSupportForm = this.fb.group({
    supplier_id: [null, []],
    practice_id: [null, []],
    professional_id: [null, []],
    second_hand_supplies_order_id: [null, []],
    reason: [null, [Validators.required]],
    message: [null, [Validators.required]],
    attachments: [null, []],
    type: ['SECOND_HAND_SUPPLY', [Validators.required]]
  });
  supportRequestReasonsList:any[];
  filterSupportRequestReasonsList:any[];
  reasonFilterCtrl = this.fb.control('');
  constructor(
    private fb: FormBuilder,
    private _dialogRef: MatDialogRef<SecondHandRequestComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sendOrderSupportRequestService: SendOrderSupportRequestService,
    private toast: ToastService,
    private getSupportRequestReasonsService: GetSupportRequestReasonsService
  ) { }

  ngOnInit(): void {
    if(this.data.id && this.data.second_hand_supply){
      this.second_hand_supplies_order_id.setValue(this.data.id);
      if(this.data.second_hand_supply.dental_supplier_id){
        this.supplier_id.setValue(this.data.second_hand_supply.dental_supplier_id);
      }
      if(this.data.second_hand_supply.dental_practice_id){
        this.practice_id.setValue(this.data.second_hand_supply.dental_practice_id);
      }
      if(this.data.second_hand_supply.dental_professional_id){
        this.professional_id.setValue(this.data.second_hand_supply.dental_professional_id);
      }
    }
    this.getSupportRequestReasonsService.getSupportRequestReasons().subscribe((supportRequestReasonsList: any[])=>{
      this.supportRequestReasonsList = supportRequestReasonsList;
      this.filterSupportRequestReasonsList = supportRequestReasonsList;
    })

    this.reasonFilterCtrl.valueChanges.subscribe(value => {
      console.log(value);
      this.filterSupportRequestReasonsList =
      this.supportRequestReasonsList.filter(single=>{
        return single.name.toLowerCase().startsWith(value.toLowerCase());
      });
    });
  }
  /* ------------------------------ CUSTOM-METHODS ----------------------------- */
  closeDialog(status: string) {
    // this._dialogRef.close(status);
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this._dialogRef.close(status); }, 1000);
  }

  /* --------------------------------- Getters -------------------------------- */
  get supplier_id(){
    return this.raiseSupportForm.get('supplier_id');
  }
  get practice_id(){
    return this.raiseSupportForm.get('practice_id');
  }
  get professional_id(){
    return this.raiseSupportForm.get('professional_id');
  }
  get second_hand_supplies_order_id(){
    return  this.raiseSupportForm.get('second_hand_supplies_order_id');
  }
  get reason() {
    return this.raiseSupportForm.get('reason');
  }
  get message() {
    return this.raiseSupportForm.get('message');
  }
  get attachments() {
    return this.raiseSupportForm.get('attachments');
  }
  get type() {
    return this.raiseSupportForm.get('type');
  }

  async sendOrderSupportRequest(){
    if(this.raiseSupportForm.invalid){
      this.toast.openSnackBar('Please enter valid details');
      return;
    }
    try {
      const orderSupportRequest = this.raiseSupportForm.value as any;
      await this.sendOrderSupportRequestService.sendOrderSupportRequest(orderSupportRequest);
      this.closeDialog('yes');
      this.toast.openSnackBar('Support request raised successfully');
    } catch(error){
      this.toast.openSnackBar('Unable to raise support request');
    }

  }

  trimMe(ac: AbstractControl){
    ac.setValue(ac.value.trim());
  }
}

